import { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../sidebar/Sidebar";
import AppTopbar from "./AppTopbar";

function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => setSidebarOpen((open) => !open);

  return (
    <div className={`drawer min-h-screen bg-white ${sidebarOpen ? "drawer-open" : ""}`}>
      <input
        id="app-drawer"
        type="checkbox"
        className="drawer-toggle"
        checked={sidebarOpen}
        onChange={(event) => setSidebarOpen(event.target.checked)}
        aria-hidden
        tabIndex={-1}
      />

      <div className="drawer-content m-0 flex min-h-screen w-full min-w-0 flex-1 flex-col bg-white p-0">
        <AppTopbar sidebarOpen={sidebarOpen} onSidebarToggle={toggleSidebar} />
        <div className="m-0 flex w-full min-w-0 flex-1 flex-col bg-white p-0">
          <Outlet />
        </div>
      </div>

      <div className="drawer-side z-20">
        <label
          htmlFor="app-drawer"
          aria-label="Close menu"
          className="drawer-overlay lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
        <Sidebar />
      </div>
    </div>
  );
}

export default AppLayout;
